import React, { ReactElement } from 'react';

export default function FamilyIcon(): ReactElement | null {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="108"
      height="94"
      fill="none"
      viewBox="0 0 108 94"
    >
      <path
        fill="#EE2020"
        fillOpacity="0.07"
        d="M67.622 0H40.467C23.088 0 9 14.07 9 31.424V62.12c0 17.355 14.088 31.424 31.467 31.424h27.155c17.379 0 31.466-14.069 31.466-31.424V31.425C99.088 14.068 85.001 0 67.623 0z"
      ></path>
      <path
        stroke="#F3AFAF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M1 80h106"
      ></path>
      <path
        fill="#F3AFAF"
        d="M76.38 33.8c-1.05-9.36-9.187-17.767-13.125-20.8 7.875 2.6 21 11.7 21 22.1-5.25 0-11.812 2.6-14.437 3.9l-6.563-2.6c1.75-.867 6.825-2.6 13.125-2.6zM41.122 34.178c3.088-.588 8.867.402 10.133 1.205-5.066 0-10.555 2.411-12.666 3.617 0 0-1.267-1.205-6.334-2.41.845-.403 3.8-1.448 8.867-2.412z"
      ></path>
      <path
        fill="#EE2020"
        d="M84.51 35.442l.031 1a1 1 0 00.938-1.25l-.969.25zm-14.637 4.163l-.5.866a1 1 0 001 0l-.5-.866zm-31.235 0l-.501.866a1 1 0 001.001 0l-.5-.866zM24 35.442l-.969-.25a1 1 0 00.938 1.25l.031-1zm60.48-1a32.068 32.068 0 00-15.108 4.298l1.002 1.73a30.068 30.068 0 0114.167-4.029l-.061-1.999zM70.374 38.74a32.091 32.091 0 00-16.119-4.314v2c5.509 0 10.671 1.473 15.117 4.045l1.002-1.731zm-16.119-4.314c-5.87 0-11.376 1.57-16.118 4.314l1.001 1.73a30.092 30.092 0 0115.117-4.044v-2zM39.138 38.74a32.068 32.068 0 00-15.107-4.298l-.062 2a30.069 30.069 0 0114.168 4.029l1.001-1.731zm-14.17-3.05C28.32 22.642 40.164 13 54.256 13v-2c-15.027 0-27.65 10.282-31.224 24.193l1.938.497zM54.256 13c14.092 0 25.935 9.642 29.287 22.69l1.937-.497C81.906 21.282 69.282 11 54.255 11v2z"
      ></path>
      <path
        stroke="#EE2020"
        strokeWidth="2"
        d="M54.255 12c-5.333 2.143-16 10.543-16 27M54.255 12c5.334 2.143 16 10.543 16 27"
      ></path>
      <path
        fill="#F3AFAF"
        stroke="#EE2020"
        strokeWidth="2"
        d="M38.737 64.79c-8.4 0-15.21 6.81-15.21 15.21h30.42c0-8.4-6.81-15.21-15.21-15.21z"
      ></path>
      <path
        fill="#F3AFAF"
        stroke="#EE2020"
        strokeWidth="2"
        d="M59.316 68.368c-6.424 0-11.632 5.208-11.632 11.632h23.263c0-6.424-5.207-11.632-11.631-11.632z"
      ></path>
      <path
        fill="#F3AFAF"
        stroke="#EE2020"
        strokeWidth="2"
        d="M75.421 71.947A8.053 8.053 0 0067.368 80h16.106a8.053 8.053 0 00-8.053-8.053z"
      ></path>
      <circle
        cx="38.737"
        cy="53.158"
        r="7.158"
        stroke="#EE2020"
        strokeWidth="2"
      ></circle>
      <circle
        cx="59.316"
        cy="59.421"
        r="5.368"
        stroke="#EE2020"
        strokeWidth="2"
      ></circle>
      <circle
        cx="75.421"
        cy="65.684"
        r="3.579"
        stroke="#EE2020"
        strokeWidth="2"
      ></circle>
      <path
        stroke="#EE2020"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M20 18L20 22"
      ></path>
      <path
        stroke="#EE2020"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M22 20L18 20"
      ></path>
      <path
        stroke="#EE2020"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M81 45L81 49"
      ></path>
      <path
        stroke="#EE2020"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M83 47L79 47"
      ></path>
      <circle cx="87.181" cy="21.181" r="1.181" fill="#EE2020"></circle>
      <circle cx="20.181" cy="60.181" r="1.181" fill="#EE2020"></circle>
    </svg>
  );
}
